import { useContextState } from "../../../../../../../../hooks/theme"


const useStyles = () => {
  const { colors } = useContextState()

  return {
    main: {
      position:'relative'
    },
    setting: (activities:boolean) => ({
      display: 'flex',
      justifyContent: 'center',
      '& .MuiSvgIcon-root': {
        color: activities ? colors.color4 : colors.color10,
      },
      '& .setting': {
        color: 'white'
      }
    }),
    settingHeader: {
      '& .MuiSvgIcon-root': {
        color: 'white',
      },
    },
    check: {
      fontSize: '12px',
      
      position: 'absolute',
      top: '2px',
      right: '3px',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
        color: colors.color8
      },
    },
    user: {
      fontSize: '12px',
      color: colors.color9,
      width: '100%',
    },
    errorsText: {
      '&.MuiTypography-root': {
          width: '100%',
          color: colors.color19,
          fontSize: '10px',
      },
  },
    unitContent: {
      fontSize: '12px',
      color: colors.color9,
      width: '100%',
    },
    action: {
      width: '100%',
      display: 'flex',
      justifyContent: 'start',
      flexWrap: 'wrap',
      '& .MuiCheckbox-root': {
        margin: 0
      }
    },
    totalActivities:{
      color: colors.color9,
      '&.MuiTypography-root':{
        fontSize:'12px',
      }
    }
  }
}

export { useStyles }